import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function KpiRouteTracker() {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const startTimeRef = useRef(performance.now());

  useEffect(() => {
    const now = performance.now();
    const duration = now - startTimeRef.current;

    if (prevPathRef.current !== location.pathname) {
      // KPI route timing logs disabled per requirements.
    }

    // Reset the timer and path for the next route change
    startTimeRef.current = now;
    prevPathRef.current = location.pathname;
  }, [location.pathname]);

  return null;
}
